export default {
    status_title: {
        CREATED: 'Pending',
        CONFIRMED: 'Confirmed',
        DECLINED: 'Declined',
        CANCELLED: 'Cancelled',
        INSURANCE_AUTH_PENDING: 'Confirmed',
        PATIENT_VISIT_PENDING: 'Confirmed',
        RESCHEDULE_REQUESTED: 'Rescheduled',
        CONSULTATION_NOTES_PENDING: 'Patient seen',
        UPLOAD_NOTES: 'Upload Notes',
        NO_SHOW: 'No Show',
        COMPLETED: 'Completed',
        RESCHEDULE_AVAILABILITY_CHANGE: 'To be rescheduled',
        ACCEPTED: 'Accepted',
        TIME_SLOTS_PROPOSED: 'Time slot proposed',
        SCHEDULED: 'Scheduled',
        INACTIVE: 'Inactive',
        RESCHEDULE_REQUESTED_BY_PATIENT: 'Reschedule request by patient',
        AWAITING_CONFIRMATION: 'Pending slot selection',
        CLOSED: 'Closed',
        EXPIRED: 'Expired',
    },

    status_description: {
        CREATED: 'Please confirm appointment',
        CONFIRMED: 'Appointment confirmed',
        DECLINED: 'You have declined the appointment',
        CANCELLED: 'Appointment cancelled',
        INSURANCE_AUTH_PENDING: 'Waiting for insurance authorization',
        PATIENT_VISIT_PENDING: 'Waiting for patient visit',
        RESCHEDULE_REQUESTED: 'Waiting for calendar to be updated',
        CONSULTATION_NOTES_PENDING: 'Consultation report pending',
        NO_SHOW: "Patient didn't show up",
        COMPLETED: 'Completed',
        RESCHEDULE_AVAILABILITY_CHANGE: 'Out of actual availability',
        ACCEPTED: 'Accepted',
        TIME_SLOTS_PROPOSED: 'Time slot proposed',
        SCHEDULED: 'Scheduled',
        INACTIVE: 'Inactive',
        INACTIVE_NEW: 'Referral Closed',
        RESCHEDULE_REQUESTED_BY_PATIENT: 'Reschedule request by patient',
    },
}
